import Api from "@/services/Api";
import BaseApi from "@/services/baseApi";

class Role_se {
    constructor() {
        this.entity = 'role';
    }

    delete(id) {
        return Api.delete(this.entity, id)
    }


    getById(id) {
        if (id && id.length > 0) {
            return Api.getById(this.entity, id)
        } else {
            return Api.new_(this.entity)
        }
    }

    getPage(page_, size_) {
        return Api.getPage(this.entity, page_, size_)
    }

    save(roleName, selected, id) {
        let formData = new FormData();
        formData.set("selectedItem", selected)
        formData.set("roleName", roleName)
        formData.set("roleId", id)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/' + this.entity + '/save/',
            headers: {'Content-Type': 'application/json'},
        })

    }


}

export default new Role_se();
